import { Component } from "@angular/core";
import { MatDialog } from "@angular/material";
import { NCashPopupComponent } from "./nCash-popup/nCash-popup.component";

@Component({
    selector: 'app-nCash',
    templateUrl: './nCash.component.html',
    styleUrls: ['./nCash.component.scss']
})
export class NCashComponent {
    private readonly matDialog: MatDialog;
    nCashFeatureList = ['Choose Your Frequency', 'Choose Your Amount', 'Choose Your Date'];
    constructor(matDialog: MatDialog) {
        this.matDialog = matDialog;
    }
    onClickKnowMore() {
        return this.matDialog.open(NCashPopupComponent, {
            panelClass: 'nCash-popup-responsive'
        });
    }
}